<template>
  <div v-if="redirect" class="container py-60">
    <p>{{ $texts('redirectMessage', 'This page has moved.') }}</p>
    <NuxtLink :to="redirect" external class="underline hover:no-underline">
      {{ $texts('redirectLink', 'Go to the new page') }}
    </NuxtLink>
  </div>
  <NodePage v-else-if="node && 'hero' in node" v-bind="node" />
  <NodeBlogArticle v-else-if="node && 'tagsField' in node" v-bind="node" />
  <GroupGroupB2b v-else-if="node?.__typename === 'GroupB2b'" v-bind="node" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PageRoute',
})

definePageMeta({
  name: 'drupal-route',
  path: '/:slug(.*)*',
  languageMapping: {
    en: '/:slug(.*)*',
    fr: '/:slug(.*)*',
  },
  drupalRoute: true,
})

const { entity: node, metatags, redirect } = await useDrupalRouteQuery('slug')
defineSchemaOrg(metatags)

await renderPageDependencies()
</script>
